export function convertScientificToNormal(num: string) {
  // Check if the number is in scientific notation
  if (/e/i.test(num)) {
    // Extract the base and the exponent
    const parts = num.split(/e/i);
    const base = parts[0];
    const exponent = parseInt(parts[1], 10);

    // Split the base into integer and fractional parts
    const [integerPart, fractionalPart] = base.split('.');

    // If there is no fractional part, initialize it as empty
    let result = integerPart || '';

    // If there is a fractional part, add it
    if (fractionalPart) {
      result += fractionalPart;
    }

    // Adjust the length of the result based on the exponent
    if (exponent > 0) {
      // Positive exponent: add zeros after the number
      const zerosToAdd = exponent - fractionalPart.length;
      for (let i = 0; i < zerosToAdd; i++) {
        result += '0';
      }
    } else if (exponent < 0) {
      // Negative exponent: add zeros before the number
      const zerosToAdd = Math.abs(exponent) - integerPart.length;
      for (let i = 0; i < zerosToAdd; i++) {
        result = '0' + result;
      }
      // Place the decimal point in the correct position
      result = '0.' + result;
    }

    return result;
  }

  // Return the number as is if it's not in scientific notation
  return num;
}
